/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: false,
  showFormData: false,
  baseUrl: '',
  apiUrl: '/api',
  uploadUrl: '/api/upload',
};
